import React, { useState } from "react";
// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Divider,
  Grid,
  Box,
  Link,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";

// project imports
import AuthWrapper1 from "../AuthWrapper1";
import SigninCardWrapper from "../SigninCardWrapper";
import Login from "../FormFields/Login";
import Logo from "../../LendingForm/FormStructure.js/images/FILending-logo.svg";
import Header from "./Home/Header";

const Index = (props) => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  // const [Postdata,setPostData]=useState({})
  // //console.log("post data", Postdata);

  return (
    <AuthWrapper1>
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        sx={{ minHeight: "85vh" }}
      >
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: "calc(85vh - 68px)" }}
          >
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <SigninCardWrapper>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item sx={{}}>
                    <Link to="#" underline="none">
                      <Box
                        component="img"
                        sx={{ height: 80 }}
                        alt="Logo"
                        src={Logo}
                      />
                      {/* <Typography sx={{color:"#A556B2"}} gutterBottom variant= 'h5'>
                        FI Lending
                      </Typography> */}
                    </Link>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction={matchDownSM ? "column-reverse" : "row"}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid item>
                        <Stack
                          alignItems="center"
                          justifyContent="center"
                          spacing={1}
                        >
                          <Typography
                            sx={{ color: "#121926" }}
                            gutterBottom
                            variant="h6"
                          >
                            Welcome to FI-Lending
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Login />
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={8}></Grid>
                </Grid>
              </SigninCardWrapper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
          {/* <AuthFooter /> */}
        </Grid>
      </Grid>
    </AuthWrapper1>
  );
};

export default Index;
